import { inject, Injectable } from '@angular/core';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { LfTranslateService } from '@leafio/ui/i18n';

const SUFFIX = 'Shelf';

@Injectable()
export class AppTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly translateService = inject(LfTranslateService);

  updateTitle(snapshot: RouterStateSnapshot): void {
    const pageTitle = this.buildTitle(snapshot) || this.title.getTitle();
    this.title.setTitle(`${this.translateService.t(pageTitle)} | ${SUFFIX}`);
  }
}
